import React from 'react';
import { FaCode, FaServer, FaDatabase } from 'react-icons/fa';

const getIcon = (index) => {
  const icons = [<FaCode />, <FaServer />, <FaDatabase />];
  return icons[index % icons.length];
};

export default getIcon;